module.exports = __webpack_public_path__ + "img/icon_zlwmw.32108085.png";